/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".main__subtitle[_ngcontent-%COMP%], .main__title[_ngcontent-%COMP%]{color:#06c;font-family:\"Berthold Imago\";font-weight:700;text-align:center}.main__title[_ngcontent-%COMP%]{font-size:42px;margin-bottom:0}.main__subtitle[_ngcontent-%COMP%]{font-size:18px;margin-bottom:50px;margin-top:40px}"];
export { styles as styles };
